import { render, staticRenderFns } from "./m-how-it-works.vue?vue&type=template&id=96a3e6c6&scoped=true"
import script from "./m-how-it-works.vue?vue&type=script&lang=js"
export * from "./m-how-it-works.vue?vue&type=script&lang=js"
import style0 from "./m-how-it-works.vue?vue&type=style&index=0&id=96a3e6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a3e6c6",
  null
  
)

export default component.exports